<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_nx.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_nx.png'
import list_img1 from '../../images/download/down-nx1.jpg'
import list_img2 from '../../images/download/down-nx2.jpg'
import list_img3 from '../../images/download/down-nx3.jpg'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'闲来宁夏麻将',
                size:'85.08',
                load_count:'458',
                desp:'闲来宁夏麻将是一个四个人才能玩的游戏。因其玩法简单、爽快，计算方便，而受到广大玩家欢迎。滑水等本地玩法更是让游戏激烈非常。麻将文化源远流长，本身是由明末盛行的马吊牌、纸牌发展演变而来。不仅具有独特的游戏特点，而且还是一种集益智性、趣味性、和博弈性的运动。',
                ios_url:'http://app6.auwvnd.cn/?downloadfrom=ningxia',
                android_url:'http://app6.auwvnd.cn/?downloadfrom=ningxia',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:''
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
